import { Link } from 'react-router-dom';
import { BrandLogo } from './Logo';
import { FOOTER_LINKS, CONTACT_EMAIL, BUSINESS_NAME } from '../data/policies';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <BrandLogo height={40} />
          <p className="footer-tag">{BUSINESS_NAME} — built for creators, not algorithms.</p>
          <p className="footer-contact">Support: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
        </div>
        <nav className="footer-links" aria-label="Legal and policy">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.slug} to={`/legal/${l.slug}`}>{l.title}</Link>
          ))}
        </nav>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {BUSINESS_NAME}. All rights reserved.</span>
        <span>By using this site you agree to our <Link to="/legal/terms">Terms</Link> and <Link to="/legal/privacy">Privacy Policy</Link>.</span>
      </div>
    </footer>
  );
}
